import PropTypes from 'prop-types';
import React from 'react';

import { SILVER_SAND, OSLO_GRAY } from '@wetransfer/transfer/constant/colors';

export const ORIENTATION_UP = 'up';

export const ORIENTATION_DOWN = 'down';

const DoubleArrows = ({ className, orientation }) => (
  <svg className={className} viewBox="0 0 17 13">
    <g fill="none" fillRule="evenodd">
      <path
        d="M5.009 3.42V9a1 1 0 1 1-2 0V3.416L1.707 4.718A1 1 0 1 1 .293 3.305L3.3.293a1 1 0 0 1 1.416.001l3 3.012A1 1 0 1 1 6.3 4.717L5.01 3.421z"
        fill={orientation === ORIENTATION_UP ? SILVER_SAND : OSLO_GRAY}
      />
      <path
        d="M12 9.58V4a1 1 0 0 1 2 0v5.584l1.301-1.302a1 1 0 1 1 1.415 1.413l-3.009 3.012a1 1 0 0 1-1.415-.001l-3-3.012a1 1 0 1 1 1.416-1.411L12 9.579z"
        fill={orientation === ORIENTATION_DOWN ? SILVER_SAND : OSLO_GRAY}
      />
    </g>
  </svg>
);

DoubleArrows.propTypes = {
  className: PropTypes.string,
  orientation: PropTypes.oneOf([ORIENTATION_UP, ORIENTATION_DOWN]),
};

DoubleArrows.defaultProps = {
  orientation: ORIENTATION_UP,
};

export default DoubleArrows;
